angular.
module("dx.webapp.node").
controller("DxNodeClientSettingsController", function NodeClientSettingsController(
	$scope,

	DX_DEPRECATION_SETTING,
	dxApi,
	dxClientVersionSort,
	dxRegion
) {
	"use strict";

	var self = this;
	self.clientVersions = [];
	self.versionsEnabled = {};
	self.isSaving = false;
	self.saved = false;

	self.DX_DEPRECATION_SETTING = DX_DEPRECATION_SETTING;

	self.selectedSetting = self.node.deprecationSetting;

	self.disableSettingChange = false;
	var BUILD_TESTING_SCHOOL = 1077368935;

	// The node is loaded asynchronously in a parent scope, so we need to update the
	// selected deprecation setting in case it's slow.
	var deregWatchNode = $scope.$watch("vm.node", function watchNode(newValue, oldValue) {
		if (newValue === oldValue) {
			return;
		}

		self.selectedSetting = self.node.deprecationSetting;
		self.disableSettingChange = dxRegion.getCurrent().key === "Europe" && self.node.id === BUILD_TESTING_SCHOOL;
		deregWatchNode();
	});

	self.deprecationSettings = [
		{value: DX_DEPRECATION_SETTING.UNMODIFIED, label: "Unmodified"},
		{value: DX_DEPRECATION_SETTING.ALLOW_ALL, label: "Allow all"},
		{value: DX_DEPRECATION_SETTING.OVERRIDE, label: "Override"},
		{value: DX_DEPRECATION_SETTING.APPEND, label: "Append"},
	];

	function isInNodeWhitelist(clientVersionId) {
		return self.node.clientWhitelist.indexOf(clientVersionId) >= 0;
	}

	self.isCheckboxesDisabled = function isCheckboxesDisabled() {
		var unmodified = self.selectedSetting === DX_DEPRECATION_SETTING.UNMODIFIED;
		var allowAll = self.selectedSetting === DX_DEPRECATION_SETTING.UNMODIFIED;

		return unmodified || allowAll;
	};

	self.onSave = function onSave() {
		self.saved = false;
		self.isSaving = true;

		var newWhiteList = [];

		for (var id in self.versionsEnabled) {
			if (!self.versionsEnabled.hasOwnProperty(id)) {
				continue;
			}

			if (self.versionsEnabled[id]) {
				newWhiteList.push(parseInt(id, 10));
			}
		}

		self.node.clientWhitelist = newWhiteList;
		self.node.deprecationSetting = self.selectedSetting;
		self.node.save().then(function onResolve() {
			self.isSaving = false;
			self.saved = true;
		});
	};

	function onClientGetResolve(response) {
		self.clientVersions = response.data.sort(dxClientVersionSort);

		for (var i = 0; i < self.clientVersions.length; i++) {
			var clientVersion = self.clientVersions[i];
			self.versionsEnabled[clientVersion.id] = isInNodeWhitelist(clientVersion.id);
		}
	}

	dxApi.v1.clientversions.get().then(onClientGetResolve);
});
